// eslint-disable-next-line import/no-extraneous-dependencies
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pathmap: {},
  querymap: {},
  historystate: null,
  user: {},
  univ: {},
  userAccess: {},
  isLocalContainer: false,
  environment: {}
};

export const account = createSlice({
  name: 'account',
  initialState,
  reducers: {
    updatePathMap: (state, action) => {
      state.pathmap = action.payload;
    },
    updateQueryMap: (state, action) => {
      state.querymap = action.payload;
    },
    updatePathMapQueryMap: (state, action) => {
      state.pathmap = action.payload.pathmap;
      state.querymap = action.payload.querymap;
      state.historystate = action.payload.historystate;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    updateUniv: (state, action) => {
      state.univ = action.payload;
    },
    updateUserAccess: (state, action) => {
      state.userAccess = action.payload;
    },
    updateIsLocalContainer: (state, action) => {
      state.isLocalContainer = action.payload;
    },
    updateEnvironment: (state, action) => {
      state.environment = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  updatePathMap,
  updateQueryMap,
  updatePathMapQueryMap,
  updateUser,
  updateUniv,
  updateUserAccess,
  updateIsLocalContainer,
  updateEnvironment
} = account.actions;

export default account.reducer;
